import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { serverUrl } from "../nestserver";

/* -------------------------------------------------------------------------- */
/*                                   Create Fun                               */
/* -------------------------------------------------------------------------- */

export function useCreateFun(mutationOptions) {
  async function createFun(data) {
    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("description", data.description || "");
    formData.append("school", data.school);
    if (data.pdf && data.pdf.length > 0) {
      data.pdf.forEach((file) => {
        formData.append("pdf", file);
      });
    }

    return axios.post(serverUrl + "/fun", formData, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        "Content-Type": "multipart/form-data",
      },
    });
  }

  return useMutation(createFun, mutationOptions);
}

/* -------------------------------------------------------------------------- */
/*                                 Get All Fun                                */
/* -------------------------------------------------------------------------- */

export function useFuns(schoolId, queryOptions) {
  async function getFuns() {
    const res = await axios.get(serverUrl + "/fun", {
      params: { school: schoolId },
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  }

  return useQuery(["funs", schoolId], getFuns, queryOptions);
}

/* -------------------------------------------------------------------------- */
/*                                Get Single Fun                              */
/* -------------------------------------------------------------------------- */

export function useGetFun(id, queryOptions) {
  async function getFun() {
    const res = await axios.get(serverUrl + "/fun/" + id, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  }

  return useQuery(["fun", id], getFun, queryOptions);
}

/* -------------------------------------------------------------------------- */
/*                                 Update Fun                                 */
/* -------------------------------------------------------------------------- */

export function useUpdateFun(mutationOptions) {
  async function updateFun([id, data]) {
    const formData = new FormData();
    if (data.name) formData.append("name", data.name);
    if (data.description) formData.append("description", data.description);
    if (data.school) formData.append("school", data.school);
    if (data.pdf && data.pdf.length > 0) {
      data.pdf.forEach((file) => {
        formData.append("pdf", file);
      });
    }

    return axios.patch(serverUrl + "/fun/" + id, formData, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        "Content-Type": "multipart/form-data",
      },
    });
  }

  return useMutation(updateFun, mutationOptions);
}

/* -------------------------------------------------------------------------- */
/*                                 Delete Fun                                 */
/* -------------------------------------------------------------------------- */

export function useDeleteFun(mutationOptions) {
  function deleteFun(id) {
    return axios.delete(serverUrl + "/fun/" + id, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
  }

  return useMutation(deleteFun, mutationOptions);
}
